export default __webpack_public_path__ + "f418b423812f0193c0a3415fd1ce501e.png";